function isInCodeBlock(selection) {
  const type = selection.$from.parent.type;
  return type.name === "code_block";
}
function isInList(selection) {
  var _a;
  const type = (_a = selection.$from.node(selection.$from.depth - 1)) == null ? void 0 : _a.type;
  return (type == null ? void 0 : type.name) === "list_item";
}
function defIfNotExists(tagName, element) {
  if (customElements.get(tagName) == null)
    customElements.define(tagName, element);
}

export { isInList as a, defIfNotExists as d, isInCodeBlock as i };
//# sourceMappingURL=index-Jvxff1vU.js.map
